import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, CollectionReference } from '@angular/fire/firestore';
import * as firebase from 'firebase';
import * as moment from 'moment'
@Injectable({
  providedIn: 'root'
})
export class UserService {
  active: boolean
  role: string
  locales: string[]
  uid: string
  nombre: string
  iban: string
  constructor(
    private afAuth: AngularFireAuth,
    private _db: AngularFirestore
  ) { }

  async setUser({role, locales, active, nombre, iban}) {
    this.uid = await (await this.afAuth.currentUser).uid
    this.role = role
    this.locales = locales
    this.active = active
    this.nombre = nombre
    this.iban = iban
  }

  getRegistros() {
    return this._db.collection('usuarios').doc(this.uid).collection('registros', ref => ref.orderBy('fecha', 'desc').limit(10)).valueChanges()
  }
  async setRegistro(local: string) {
    const add = (accion: string) => this._db.collection('usuarios').doc(this.uid).collection('registros').add({fecha: new Date() , accion, local})
    const fechas = (ref: CollectionReference) => {
      return ref.where('fecha', '>=', new Date(moment().startOf('day').format('YYYY-MM-DD HH:mm') ))
        .where('fecha', '<', new Date(moment().endOf('day').format('YYYY-MM-DD HH:mm') )).orderBy('fecha','desc').limit(1)
    }
    const data = await this._db.collection('usuarios').doc(this.uid).collection('registros', fechas).get().toPromise()
    if(data.empty) {
      return add('entrada')
    }
    return data.docs.forEach( snap => {
      const last = snap.data()
      if(last.accion == 'entrada') add('salida')
      else add('entrada')
    })
  }

  getNominas(uid?: string) {
    const _uid = uid || this.uid;
    return  this._db.collection('usuarios').doc( _uid ).collection('nominas').valueChanges()
  }
  updateIBAN(iban: string) {
    return this._db.collection('usuarios').doc(this.uid).update({iban})
  }
  uploadNomina(uid: string, url: string) {
    const payload  = {
      fecha: firebase.firestore.FieldValue.serverTimestamp(),
      url
    }
    return this._db.collection('usuarios').doc(uid).collection('nominas').add(payload)
  }

    public fn_ValidateIBAN(IBAN) {

      //Se pasa a Mayusculas
      IBAN = IBAN.toUpperCase();
      //Se quita los blancos de principio y final.
      IBAN = IBAN.trim();
      IBAN = IBAN.replace(/\s/g, ""); //Y se quita los espacios en blanco dentro de la cadena

      let letra1,letra2,num1,num2;
      let isbanaux;
      let numeroSustitucion;
      //La longitud debe ser siempre de 24 caracteres
      if (IBAN.length != 24) {
          return false;
      }

      // Se coge las primeras dos letras y se pasan a números
      letra1 = IBAN.substring(0, 1);
      letra2 = IBAN.substring(1, 2);
      num1 = this._getnumIBAN(letra1);
      num2 = this._getnumIBAN(letra2);
      //Se sustituye las letras por números.
      isbanaux = String(num1) + String(num2) + IBAN.substring(2);
      // Se mueve los 6 primeros caracteres al final de la cadena.
      isbanaux = isbanaux.substring(6) + isbanaux.substring(0,6);

      //Se calcula el resto, llamando a la función modulo97, definida más abajo
      let resto = this._modulo97(isbanaux);
      if (resto == 1){
          return true;
      }else{
          return false;
      }
  }

  private _modulo97(iban): number {
      var parts = Math.ceil(iban.length/7);
      var remainer = "";

      for (var i = 1; i <= parts; i++) {
          remainer = String(parseFloat(remainer+iban.substr((i-1)*7, 7))%97);
      }

      return +remainer;
  }

  private _getnumIBAN(letra) {
      let ls_letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      return ls_letras.search(letra) + 10;
  }
}
